import { Component, Vue } from 'vue-property-decorator';
import {
  getTitle,
  getFavicons,
  getSeoMeta,
  getInlineCss,
  replaceDocumentHeadContext,
} from '~/mixins/HeadManagement';

@Component
export default class HeadManagement extends Vue {
  public mounted() {
    this.replaceHead();
  }

  protected replaceHead() {
    const title = getTitle(this);

    if (title) {
      document.title = title;
    }

    const seoMeta = getSeoMeta(this);

    if (seoMeta) {
      replaceDocumentHeadContext('seoMeta', seoMeta);
    }

    const favicons = getFavicons();

    if (favicons) {
      replaceDocumentHeadContext('favicons', favicons);
    }

    const inlineCss = getInlineCss(this);

    if (inlineCss) {
      replaceDocumentHeadContext('inlineCss', inlineCss);
    }
  }
}
